<div class="tt-submission-mediator">
  <keep-alive include="review-form">
    <component :is="currentPage" 
               v-bind="currentPageProps"
               @pageLoading="pageLoading"
               @pageLoaded="pageLoaded"
               @showPopoverMessage="onShowPopoverMessage"
               @showError="onShowError"></component>
  </keep-alive>
</div>
